import {
    WISHLIST_UPDATE_WISHLIST_NAME,
    WISHLIST_SET_ACTIVE,
    WISHLIST_SHOW_ACTIVE,
    WISHLIST_ADD_TO_CART,
    WISHLIST_ADD_ALL_TO_CART,
    WISHLIST_GET,
    WISHLIST_GET_LINK,
    WISHLIST_GET_ALL,
    WISHLIST_GET_SUMMARY,
    WISHLIST_DELETE,
    WISHLIST_DELETE_ITEM,
    WISHLIST_ADD,
    WISHLIST_ADD_ALL_TO_LIST_MESSAGE,
    REMOVE_ERROR,
    WISHLIST_SET_IN_WISHLIST,
    WISHLIST_SET_INCLUDED_IN_WISHLISTS,
} from '../constants';

export const wishlist = (
    state = {
        payload: null,
        wishlistName: '',
        lists: {},
        list: [],
        active: '',
        show: false,
        inWishlist: false,
        includedInWishlists: [],
        summary: {},
    },
    action
) => {
    switch (action.type) {
        case WISHLIST_ADD_TO_CART:
            return {
                ...state,
                payload: action.payload,
            };
        case WISHLIST_ADD_ALL_TO_CART:
            return {
                ...state,
                payload: action.payload,
            };
        case WISHLIST_UPDATE_WISHLIST_NAME:
            return {
                ...state,
                lists: state.lists.map((item) => {
                    if (item.name === action.payload.previousName) {
                        return {
                            ...item,
                            name: action.payload.newName,
                        };
                    }
                    return item;
                }),
            };
        case WISHLIST_DELETE:
            return {
                ...state,
                lists: state.lists.filter(
                    (item) => item.name !== action.payload.wishlistName
                ),
            };
        case WISHLIST_DELETE_ITEM:
            return {
                ...state,
                list: state.list.filter(
                    (item) => item.sortIndex !== action.payload.sortIndex
                ),
            };
        case WISHLIST_SET_ACTIVE:
            return {
                ...state,
                active: action.payload,
            };
        case WISHLIST_SHOW_ACTIVE:
            return {
                ...state,
                show: action.payload,
            };
        case WISHLIST_ADD:
            return {
                ...state,
                payload: action.payload,
            };
        case WISHLIST_ADD_ALL_TO_LIST_MESSAGE:
            return {
                ...state,
                payload: action.payload,
            };
        case WISHLIST_GET:
            return {
                ...state,
                payload: action.payload,
                list: action.payload.list,
            };
        case WISHLIST_GET_LINK:
            return {
                ...state,
                sharelink: action.payload.link,
            };
        case WISHLIST_GET_ALL:
            return {
                ...state,
                payload: action.payload,
                lists: action.payload.lists,
            };
        case WISHLIST_GET_SUMMARY:
            return {
                ...state,
                ...action.payload,
            };
        case REMOVE_ERROR:
            return {
                ...state,
                payload: {},
            };
        case WISHLIST_SET_IN_WISHLIST:
            return {
                ...state,
                inWishlist: action.inWishlist,
            };
        case WISHLIST_SET_INCLUDED_IN_WISHLISTS:
            return {
                ...state,
                includedInWishlists: action.includedInWishlists,
            };
        default:
            return state;
    }
};
